import { types } from "./authActions";

const userInfo = localStorage.getItem("userInfo");

const INITIAL_STATE = userInfo
  ? JSON.parse(userInfo)
  : {
      isLoggingIn: false,
      token: "",
      loja: {},
      lojas: [],
      isAdmin: false,
      role: {},
      // devolution: true,
    };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.AUTH_LOGIN:
      localStorage.setItem("apptoken", action.payload.token);
      localStorage.setItem("userInfo", JSON.stringify({ ...action.payload }));
      return { ...state, ...action.payload };
    case types.AUTH_LOGOUT:
      localStorage.removeItem("apptoken");
      localStorage.removeItem("userInfo");
      return { ...state, user: null, isLoggingIn: false, token: "" };
    case types.AUTH_CHANGE_STORE:
      const newState = { ...state, loja: action.payload };
      localStorage.setItem("userInfo", JSON.stringify(newState));
      return newState;
    case types.AUTH_CLEAR_STORE:
      return { ...state, user: null };
    // case types.SET_DEVOLUTION:
    //   return { ...state, devolution: action.payload };
    default:
      return state;
  }
};
